import ButtonChat from "@/components/shared/futureChat/buttons/ButtonChat";
import { CardBulletPoint } from "@/components/shared/futureChat/cards/CardBulletPoint";
import Check from "@/components/shared/icons/Check";
import { TrackingContext } from "@/components/shared/tracking/Tracking";
import { cn } from "@/lib/utils";
import ExportedImage from "next-image-export-optimizer";
import { useContext, useEffect } from "react";

type HintProps = {
    onCall: () => void;
    onCancel: () => void;
};

//TODO: Delete Component, not in use
const Hint: React.FC<HintProps> = ({ onCall, onCancel }) => {
    const { trackView, screenView } = useContext(TrackingContext);
    useEffect(() => { 
        screenView('X.1 - Tutorial')
    }, [])

    return (
        <div className="flex h-full w-full flex-col items-center bg-dark-300">
            {/*<div className="absolute h-full w-full max-w-[768px]">
                <ExportedImage
                    src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/webchat/LenaYoung.png`}
                    alt="HeroSteleInfo"
                    layout="fill"
                    objectFit="cover"
                    objectPosition="center"
                />
            </div>*/}
            <div className="flex w-full justify-center">
                <div className="relative h-[211px] w-[330px]">
                    {/* <ExportedImage
                        src={`${process.env.NEXT_PUBLIC_BASE_PATH}/images/ClaimWithLabel.png`}
                        alt={"Claim"}
                        layout="fill"
                        objectFit="cover"
                        objectPosition="center"
                    /> */}
                </div>
            </div>
            <div
                className={cn(
                    "absolute bottom-[46px] flex w-full flex-col gap-[14px] px-[16px]",
                    "2xs:bottom-[68px] 2xs:w-[364px] 2xs:px-0",
                )}
            >
                <div className="flex flex-col gap-2">
                    <div className="font-frutigerBlackItalic text-[16px] uppercase leading-[135%] tracking-minus-2">
                        WICHTIGE HINWEISE
                    </div>
                    <div className="flex flex-col gap-1">
                        <CardBulletPoint icon={<Check width="14" height="14" />}>
                            Nur du siehst das Video
                        </CardBulletPoint>
                        <CardBulletPoint icon={<Check width="14" height="14" />}>
                            Keine Fotos und Videos werden jemals gespeichert
                        </CardBulletPoint>
                        <CardBulletPoint icon={<Check width="14" height="14" />}>
                            Keine Weitergabe deiner Informationen an andere Firmen oder Personen
                        </CardBulletPoint>
                    </div>
                </div>
                <div className="flex flex-col gap-[12px]">
                    <ButtonChat
                        variant="primary"
                        onClick={() => {
                            onCall();
                            trackView("startcall");
                        }}
                    >
                        Ja, ich will anrufen
                    </ButtonChat>
                    <ButtonChat
                        variant="secondary"
                        onClick={() => {
                            onCancel();
                            trackView("donotstartcall");
                        }}
                    >
                        Nein danke, heute nicht
                    </ButtonChat>
                </div>
            </div>
            {/*<div className="absolute bottom-[7.89px] flex w-full items-center justify-center gap-[26.14px] font-frutigerBold text-[10px] leading-[100%] text-dark-500">
                <a href="./" className="underline">
                    Datenschutzhinweise
                </a>
                <a href="./" className="underline">
                    Impressum
                </a>
            </div>*/}
        </div>
    );
};

export default Hint;
